// extracted by mini-css-extract-plugin
export default {"WelcomeWrapper":"welcome_WelcomeWrapper__pTATP","logo":"welcome_logo__V4wa5"};